import gql from 'graphql-tag';

export const DEAL_ACTIVITY_COUNT = gql`
  query DealActivityCount($input: DealActivityCountInput!) {
    dealActivity {
      result: dealActivityCount(input: $input) {
        error
        success
        entity
      }
    }
  }
`;
